import { SxProps, Theme } from "@mui/material";

export const pillToggleGroupStyles: SxProps<Theme> = {
    bgcolor: (theme) => theme.palette.background.default,
    borderRadius: "50px",
    padding: "4px",
    width: "100%",
    "& .MuiToggleButton-root": {
        borderRadius: "50px",
        textTransform: "none",
        fontWeight: 500,
        border: "none",
        color: (theme) => theme.palette.text.secondary,
        flex: 1,
        transition: "all 0.2s ease",
        "&.Mui-selected": {
            bgcolor: (theme) => theme.palette.background.paper,
            color: (theme) => theme.palette.primary.main,
            boxShadow: (theme) => theme.palette.shadow.primaryGlow,
            "&:hover": { bgcolor: (theme) => theme.palette.background.paper },
        },
        "&:hover": {
            bgcolor: "transparent",
            color: (theme) => theme.palette.primary.main,
        },
    },
};